import { isEmpty } from 'lodash-es';
import type { FC } from 'react';
import styled, { css } from 'styled-components';

import { spaceL, spaceXS } from '@xing-com/tokens';

import { Tag } from '../tag';

const TagsContainer = styled.div<{ $highlighted: boolean }>`
  ${({ $highlighted }) =>
    $highlighted
      ? css`
          & {
            margin-top: calc(${spaceL} + ${spaceXS});
          }
        `
      : null}
`;

export interface IProps {
  getTagHref?: (tag: string) => string | undefined;
  highlighted?: boolean;
  tagDataQa?: string;
  tags: Array<string>;
}

export const TagsList: FC<IProps> = ({
  getTagHref,
  highlighted,
  tagDataQa,
  tags,
}) => {
  if (isEmpty(tags)) {
    return null;
  }

  return (
    <TagsContainer $highlighted={!highlighted}>
      {tags.map((tag) => (
        <Tag key={tag} href={getTagHref?.(tag)}>
          <div data-qa={tagDataQa}>{tag}</div>
        </Tag>
      ))}
    </TagsContainer>
  );
};
